import React from 'react'

import { Form, Col } from '_zari/core'

const FlagMostrarComplementosFormGroup = ({ iValue, onClick }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Form.Checkbox
          checked={iValue}
          id='checkbox-mostrarComplementos'
          name='checkbox-mostrarComplementos'
          label='Mostrar configuración'
          onClick={onClick}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagMostrarComplementosFormGroup)
